export default __webpack_public_path__ + "static/media/down-circle.0dd7ef46.svg";